import {  NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function AdminSidebar({ sidebarOpen, setSidebarOpen }) {
  
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    `flex items-center px-3 py-2 rounded-md transition font-medium
     ${isActive ? "bg-[#895712] text-white" : "text-[#895712]  hover:bg-[#895712]/30 hover:text-brandOrange"}`;


  const handleLogout = () => {
    localStorage.removeItem("admin-token");
    navigate("/login");   // ✅ correct
  };

  return (
    <>
      {/* OVERLAY (Mobile Only) */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 md:hidden z-10"
        ></div>
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          bg-[#f8ede3] text-[#895712] md:w-64 w-full p-6 md:pt-32 
          fixed md:static top-[160px] left-0 h-100 z-20 
          transform transition-transform duration-300
          ${sidebarOpen ? "translate-y-[1px]" : "-translate-y-[500px] md:translate-y-0"}
        `}
      >
        <h2 className="text-2xl font-brand font-bold hidden md:block text-[#895712] mb-2 ml-1">
          Admin Panel
        </h2>

        <nav className="space-y-2" onClick={() => setSidebarOpen(false)}>
          <NavLink to="/admin" end className={linkClass}>
            <i className="fa-solid fa-gauge mr-2"></i> Dashboard
          </NavLink>

          <NavLink to="/admin/portfoliolist" className={linkClass}>
            <i className="fa-solid fa-box mr-2"></i> Portfolio
          </NavLink>

          <NavLink to="/admin/adminlist" className={linkClass}>
            <i className="fa-solid fa-users mr-2"></i>All Admin
          </NavLink>

          <button
            onClick={handleLogout}
            className={linkClass}
          >
            <i className="fa-solid fa-right-from-bracket mr-2 ml-3"></i> Logout
          </button>

        </nav>
      </aside>
    </>
  );
}
